import * as yup from "yup"
import validationMessages from "@utils/validation/messages";

const conditionsRequired = () =>
    yup.boolean()
        .oneOf([true], validationMessages.conditions)

export default conditionsRequired